<template>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text @click="()=>{this.$router.go(-1)}"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
        <h1>{{singular}}</h1>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="dataLoader"
            style="margin-left: 10px;"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>Weekly Schedule</h2>
        <span class="d-flex flex-column" v-for="(item, index) in appointmentSchedule.weekly" :key="index">
          <span class="mb-2 pa-3 d-flex flex-row justify-space-between align-center" style="border: 1px solid rgba(0,0,0,0.5); border-radius: 10px;">
            <span class="d-flex flex-row">
              <p class="mr-2">{{getDayWord(index)}}:</p>
              <v-chip class="mr-1" v-for="(block,y) in item" :key="y">{{ block }}</v-chip>
            </span>
            <span>
              <v-btn @click="openEditWeeklyDialog(item, index)">Edit</v-btn>
            </span>
          </span>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="d-flex flex-row">
          <h2>Exemptions</h2>
          <v-btn fab color="success" class="ml-2" x-small @click="openCreateExemptionDialog()"><v-icon>mdi-plus</v-icon></v-btn>
        </span>
        <span class="d-flex flex-column" v-for="(item, index) in appointmentSchedule.dayExemptions" :key="index">
          <span class="mb-2 pa-3 d-flex flex-row justify-space-between align-center" style="border: 1px solid rgba(0,0,0,0.5); border-radius: 10px;">
            <span>
              <p>Repeating: {{ item.repeating }}</p>
              <p>Day: {{ item.day }}</p>
              <p>Label: {{ item.label }}</p>
              <p v-if="item.allowedTimes">Allowed Blocks: <v-chip class="mr-1" v-for="(block, index) in item.allowedTimes" :key="index">{{block}}</v-chip></p>
            </span>
            <span>
              <v-btn @click="openEditExemptionDialog(item)">Edit</v-btn>
              <v-btn @click="openDeleteExemptionDialog(item)" color="error" class="ml-2">Delete</v-btn>
            </span>
          </span>
        </span>
      </v-col>
    </v-row>
    <v-dialog scrollable v-model="editWeeklyDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>Edit Schedule for {{ getDayWord(editWeeklyDialog.index) }}s</v-card-title>
        <v-card-text class="pa-5 d-flex flex-row">
          <div style="width:60%;">
            <p>{{ editWeeklyDialog.data }}</p>
            <h3>Allowed Blocks </h3>
            <b>Only blocks specified here will be shown.</b>
            <span class="d-flex flex-row">
              <v-text-field placeholder="eg 14:30" clearable v-model="editWeeklyDialog.newBlock" label="Add Block (24h time)" dense outlined></v-text-field>
              <v-btn class="ml-2" color="success" @click="addNewBlock()">Add</v-btn>
            </span>
            <div style="background-color: rgba(0,0,0,0.25); width: 100%;" class="pa-3 mb-2 d-flex flex-row justify-space-between" v-for="(block,index) in editWeeklyDialog.data" :key="index">
              <span>{{ block }}</span>
              <v-icon @click="removeBlock(index)">mdi-close</v-icon>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeEditWeeklyDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="updateWeekly()" :loading="editWeeklyDialog.isLoading">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="editExemptionDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>Edit Exemption</v-card-title>
        <v-card-text class="pa-5 d-flex flex-row">
          <div style="width:60%;">
            <span class="d-flex flex-column mr-3">
              {{ editExemptionDialog.data }}
              <v-text-field v-model="editExemptionDialog.data.label"  label="Label" outlined></v-text-field>
              <v-radio-group v-model="editExemptionDialog.data.repeating">
                <v-radio
                v-for="(item,index) in repeatingValues"
                :key="index"
                :value="item.value"
                :label="item.label"
                >
              </v-radio>
            </v-radio-group>
            <v-text-field v-model="editExemptionDialog.data.day"  label="Day Value" outlined></v-text-field>
            <span v-if="editExemptionDialog.data.repeating=='Y'">Day format for Yearly Repeating: DD/MM</span>
            <span v-if="editExemptionDialog.data.repeating=='M'">Day format for Monthhly Repeating: M (Jan - 1; December - 12)</span>
            <span v-if="editExemptionDialog.data.repeating=='W'">Day format for Weekly Repeating: W (Day of the week, Sun - 0; Sat - 6 )</span>
            <span v-if="editExemptionDialog.data.repeating=='N'">Day format for Non-Repeating: YYYY-MM-DD</span>
            </span>
          </div>
          <div>
            <h3>Allowed Blocks </h3>
            <b>Only blocks specified here will be allowed for this date.</b>
            <span class="d-flex flex-row">
              <v-text-field placeholder="eg 14:30" clearable v-model="editExemptionDialog.newAllowedBlock" label="Add Allowed Block (24h time)" dense outlined></v-text-field>
              <v-btn class="ml-2" color="success" @click="addNewAllowedBlock()">Add</v-btn>
            </span>
            <div style="background-color: rgba(0,0,0,0.25); width: 100%;" class="pa-3 mb-2 d-flex flex-row justify-space-between" v-for="(block,index) in editExemptionDialog.data.allowedTimes" :key="index">
              <span>{{ block }}</span>
              <v-icon @click="removeAllowedBlock(index)">mdi-close</v-icon>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeEditExemptionDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="updateExemption()" :loading="editExemptionDialog.isLoading">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="createExemptionDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>Create Exemption</v-card-title>
        <v-card-text class="pa-5 d-flex flex-row">
          <div style="width:60%;">
            <span class="d-flex flex-column mr-3">
              {{ createExemptionDialog.data }}
              <v-text-field v-model="createExemptionDialog.data.label"  label="Label" outlined></v-text-field>
              <v-radio-group v-model="createExemptionDialog.data.repeating">
                <v-radio
                v-for="(item,index) in repeatingValues"
                :key="index"
                :value="item.value"
                :label="item.label"
                >
              </v-radio>
            </v-radio-group>
            <v-text-field v-model="createExemptionDialog.data.day"  label="Day Value" outlined></v-text-field>
            <span v-if="createExemptionDialog.data.repeating=='Y'">Day format for Yearly Repeating: MM/YY</span>
            <span v-if="createExemptionDialog.data.repeating=='M'">Day format for Monthhly Repeating: M (Jan - 1; December - 12)</span>
            <span v-if="createExemptionDialog.data.repeating=='D'">Day format for Daily Repeating: D (Day of the week, Sun - 0; Sat - 6 )</span>
            <span v-if="createExemptionDialog.data.repeating=='N'">Day format for Non-Repeating: YYYY-MM-DD</span>
            </span>
          </div>
          <div>
            <h3>Allowed Blocks </h3>
            <b>Only blocks specified here will be allowed for this date.</b>
            <span class="d-flex flex-row">
              <v-text-field placeholder="eg 14:30" clearable v-model="createExemptionDialog.newAllowedBlock" label="Add Allowed Block (24h time)" dense outlined></v-text-field>
              <v-btn class="ml-2" color="success" @click="addNewAllowedBlock()">Add</v-btn>
            </span>
            <div style="background-color: rgba(0,0,0,0.25); width: 100%;" class="pa-3 mb-2 d-flex flex-row justify-space-between" v-for="(block,index) in createExemptionDialog.data.allowedTimes" :key="index">
              <span>{{ block }}</span>
              <v-icon @click="removeAllowedBlock(index)">mdi-close</v-icon>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeEditExemptionDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="createExemption()" :loading="createExemptionDialog.isLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="deleteExemptionDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>Delete Exemption</v-card-title>
        <v-card-actions>
          <v-btn color="error" @click="closeDeleteExemptionDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="deleteExemption()" :loading="deleteExemptionDialog.isLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
  name: 'Home',
  data () {
    return {
      dataLoader: false,
      formLoader: false,
      imageRules: [
        v => !v || v.size < 1024000 || 'Logo size should be less than 1 MB!',
      ],
      imgFile: '',
      snackObj: {
        color: '',
        text: ''
      },
      repeatingValues: [
        {label: 'Year', value: 'Y'},
        {label: 'Month', value: 'M'},
        {label: 'Week', value: 'W'},
        {label: 'None Repeating', value: 'N'},
      ],
      isEditable: false,
      isCreate: true,

      singular: "Appointmment Schedule",
      singularLower: "appointmentschedule",
      plural: "Appointmment Schedules",
      pluralLower: "appointmentschedules",

      requiredRules: [
        v => !!v || 'Field is required.'
      ],

      data: [],
      form: {},
      validForm: false,

      headers: [
        { text: 'Repeating', align: 'start', value: 'repeating' },
        { text: 'Day', value: 'day' },
        { text: 'Label', value: 'label' },
        { text: 'Blocked Times', value: 'blockedTimes' },
      ],
      appointmentSchedule: {},
      editWeeklyDialog: {
        isOpen: false,
        data: {},
        isLoading: false,
        newBlock:""
      },
      editExemptionDialog: {
        isOpen: false,
        data: {},
        isLoading: false,
        newAllowedBlock: ""
      },
      createExemptionDialog: {
        isOpen: false,
        data: {},
        isLoading: false,
        newAllowedBlock: ""
      },
      deleteExemptionDialog: {
        isOpen: false,
        data: {},
        isLoading: false,
        newAllowedBlock: ""
      },
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', 'getGlobalValue'])
  },
  async mounted(){
    try { 
      this.dataLoader = true;
      this.appointmentSchedule = this.getGlobalValue('APPOINTMENT_AVAILABILITY_SCHEDULE')
      console.log(this.appointmentSchedule)
    } catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    }finally {
      this.dataLoader = false;
    }
  },
  methods: {
    addNewAllowedBlock(){
      if(!this.editExemptionDialog.newAllowedBlock) return
      if(!this.editExemptionDialog.data.allowedTimes)
        this.editExemptionDialog.data.allowedTimes =  []

      if(this.editExemptionDialog.newAllowedBlock.length == 1){
        this.editExemptionDialog.newAllowedBlock = `${this.editExemptionDialog.newAllowedBlock}:00`
      }
      
      if(!this.editExemptionDialog.newAllowedBlock.includes(":")){
        this.snack('Time format wrong. (HH:MM)')
        return
      }

      let hours = this.editExemptionDialog.newAllowedBlock.split(':')[0]
      let minutes = this.editExemptionDialog.newAllowedBlock.split(':')[1]
      minutes = minutes.padEnd(2,0).padStart(2,0)
      console.log(hours,minutes)      

      let newBlock = hours+":"+minutes

      if(this.editExemptionDialog.data.allowedTimes.includes(newBlock)){
        this.snack("Block already exists.")
        return
      }
      
      this.editExemptionDialog.data.allowedTimes.push(newBlock)
      this.editExemptionDialog.newAllowedBlock = ""
    },
    removeAllowedBlock(index){
      console.log(index, this.editExemptionDialog.data.allowedTimes)
      this.editExemptionDialog.data.allowedTimes.splice(index,1)
      this.$forceUpdate()
    },
    addNewBlock(){
      if(!this.editWeeklyDialog.newBlock) return
      if(!this.editWeeklyDialog.data)
        this.editWeeklyDialog.data =  []

      if(this.editWeeklyDialog.newBlock.length == 1){
        this.editWeeklyDialog.newBlock = `${this.editWeeklyDialog.newBlock}:00`
      }
      
      if(!this.editWeeklyDialog.newBlock.includes(":")){
        this.snack('Time format wrong. (HH:MM)')
        return
      }

      let hours = this.editWeeklyDialog.newBlock.split(':')[0]
      let minutes = this.editWeeklyDialog.newBlock.split(':')[1]
      minutes = minutes.padEnd(2,0).padStart(2,0)
      console.log(hours,minutes)      

      let newBlock = hours+":"+minutes

      if(this.editWeeklyDialog.data.includes(newBlock)){
        this.snack("Block already exists.")
        return
      }
      
      this.editWeeklyDialog.data.push(newBlock)
      this.resortWeeklyBlocks()
      this.editWeeklyDialog.newBlock = ""
    },
    removeBlock(index){
      console.log(index, this.editWeeklyDialog.data)
      this.editWeeklyDialog.data.splice(index,1)
      this.resortWeeklyBlocks()
      this.$forceUpdate()
    },
    openEditWeeklyDialog(data, index){
      this.editWeeklyDialog.isOpen = true
      this.editWeeklyDialog.data = data
      if(index || index == 0) this.editWeeklyDialog.index = index
    },
    closeEditWeeklyDialog(){
      this.editWeeklyDialog = {
        isOpen: false,
        data: {},
        isLoading: false,
        newBlock: ""
      }
    },
    openCreateExemptionDialog(){
      this.createExemptionDialog.isOpen = true
      this.createExemptionDialog.newAllowedBlock = ""
    },
    closeCreateExemptionDialog(){
      this.createExemptionDialog = {
        isOpen: false,
        data: {},
        isLoading: false,
        newAllowedBlock: ""
      }
    },
    resortWeeklyBlocks(){ // re-sort NOT resort like a hotel
      this.editWeeklyDialog.data.sort((a,b)=>{
        return parseInt(a.replace(":","")) - parseInt(b.replace(":",""))
      })
    },
    openEditExemptionDialog(data){
      this.editExemptionDialog.data = data
      this.editExemptionDialog.isOpen = true
      this.editExemptionDialog.newAllowedBlock = ""
    },
    closeEditExemptionDialog(){
      this.editExemptionDialog = {
        isOpen: false,
        data: {},
        isLoading: false,
        newAllowedBlock: ""
      }
    },
    openDeleteExemptionDialog(data){
      this.deleteExemptionDialog.data = data
      this.deleteExemptionDialog.isOpen = true
      this.deleteExemptionDialog.newAllowedBlock = ""
    },
    closeDeleteExemptionDialog(){
      this.deleteExemptionDialog = {
        isOpen: false,
        data: {},
        isLoading: false,
        newAllowedBlock: ""
      }
    },
    async updateWeekly(){
      try {
        this.editWeeklyDialog.isLoading = true
        console.log("sdfsdf", this.editWeeklyDialog.index)
        let obj = {index: this.editWeeklyDialog.index.toString(), data: this.editWeeklyDialog.data}
        if(!obj.data) obj.data = []

        let res = await axios.put(`${this.getEndpoint}/api/appointmentAvailabilitySchedule/weekly`, obj)
        
        if(res.data.error) throw res.data.error
        this.snack("Updated")
        this.closeEditWeeklyDialog()
      } catch (error) {
        console.log(error)
        this.snack(error.msg)
      } finally {
        this.editWeeklyDialog.isLoading = false
      }
    },
    async createExemption(){
      try {
        this.createExemptionDialog.isLoading = true
        let res = await axios.post(`${this.getEndpoint}/api/appointmentAvailabilitySchedule/exemption`, this.createExemptionDialog.data)
        if(res.data.error) throw res.data.error
        this.snack("Created.")
        this.closeCreateExemptionDialog()
      } catch (error) {
        console.log(error)
        this.snack(error.msg)
      } finally {
        this.createExemptionDialog.isLoading = false
      }
    },
    async updateExemption(){
      try {
        this.editExemptionDialog.isLoading = true
        let res = await axios.put(`${this.getEndpoint}/api/appointmentAvailabilitySchedule/exemption`, this.editExemptionDialog.data)
        if(res.data.error) throw res.data.error
        this.snack("Updated")
        this.closeEditExemptionDialog()
      } catch (error) {
        console.log(error)
        this.snack(error.msg)
      } finally {
        this.editExemptionDialog.isLoading = false
      }
    },
    async deleteExemption(){
      try {
        this.deleteExemptionDialog.isLoading = true
        let res = await axios.delete(`${this.getEndpoint}/api/appointmentAvailabilitySchedule/exemption/${this.deleteExemptionDialog.data.id}`)
        if(res.data.error) throw res.data.error
        this.snack("Deleted")
        this.closeDeleteExemptionDialog()
      } catch (error) {
        console.log(error)
        this.snack(error.msg)
      } finally {
        this.deleteExemptionDialog.isLoading = false
      }
    },
    getDayWord(i){
      let wordDayOfWeek = ["Sunday","Monday", "Tuesday","Wednesday", "Thursday", "Friday", "Saturday"]
      return wordDayOfWeek[i]
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
  }
}
</script>
